import styled from 'styled-components';

export const NpsFeedbackStyled = styled.div`
  .modalHeader {
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e3e9ef;
    padding: 24px 16px;
    .title {
      flex: 1;
      font-size: 16px !important;
      font-weight: 700;
      line-height: 22px;
      color: #031a32;
    }
    .closeBtn {
      border: 0;
      background: transparent !important;
    }
  }
  .numberRating {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 0 0;
    .number {
      width: 30px;
      height: 32px;
      text-align: center;
      border-radius: 8px;
      padding: 4px;
      color: #031a32;
      background-color: #fed8da;
      cursor : pointer;
    }

    .number.selected {
      color: #ffffff;
      background-color: #1976d2 !important;
    }
    .number:nth-child(8),
    .number:nth-child(9) {
      background-color: #ffe9d3;
    }

    .number:nth-child(10),
    .number:nth-child(11) {
      background-color: #d0f1d5;
    }

    ${'' /* @media (max-width: 767px) {
      .number {
        width: 28px;
        height: 28px;
        font-size: 14px;
        margin-right: 5px;
        margin-bottom: 5px;
      }
    } */}
  }
  .npsSection{
    padding: 16px 16px 0;
    .bottomBorder{
      border-bottom: 1px solid #E3E9EF;
    }
    .npsTitle{
      color: #031A32;
      font-family: Mulish;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
    }
    .npsSubTtitle{
      color: #607285;
      font-family: Mulish;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 19px;
      padding-bottom: 10px;
    }
    .npsQuestionWrapper{
      padding: 0 0 16px;
      .npsQuestion{
        color: #031A32;
        padding: 0 0 10px;
        font-family: Mulish;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
      }
      .npsStar{
        margin: 0;
        ul{
          margin: 0;
        }
        &.disabled {
          pointer-events: none;
        }
      }
      .npsTextArea{
        .textarea{
          height: 46px !important;
          max-height: 200px;
          padding: 0.5rem 0.25rem;

          &:disabled {
            background-color: #fff;
            opacity: 1;
          }

        }
      }
    }
    .npsQuestionWrapper.chipButton {
      padding-bottom: 0px !important;
    }
    .npsSubmit{
      display: flex;
      justify-content: center;
      .btn{
        min-width: 16vw;
        margin: 0;
      }
    }
    &.modalFooter {
      padding: 0 16px 16px;
    }
  }

  .modalBody{
    .npsSection{
      &:first-child .npsQuestionWrapper{
        padding-bottom: 0;
      }
    }
  }



  .like {
    display: flex;
    justify-content: space-between;
    color: #78909c;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    padding: 10px 0 20px;
  }
`;
